const localNotifications = {
  'local-notifications-breadcrumbs': 'Локальные уведомления',
  'local-notifications-filter-title': 'Фильтр локальных уведомлений',
  'local-notifications-form-id-placeholder': 'ID уведомления',
  'local-notifications-form-title-placeholder': 'Название уведомления',
  'unable-edit-sended-item-notification': 'Редактирование невозможно, данная запись уже отправлена',
};

export default localNotifications;
